import { gql } from '@apollo/client';

export const UPDATE_PORTFOLIO = gql`
  mutation UPDATE_PORTFOLIO($portfolioId: Int!, $data: UpdatePortfolioDto!) {
    updatePortfolio(portfolioId: $portfolioId, data: $data) {
      id
      userId
      image
      title
      url
      description
      genres
      tags
      teamMembers
      videoUrl
      createdAt
    }
  }
`;
